import { render, staticRenderFns } from "./StatusVerificationRejected.vue?vue&type=template&id=60effed1&"
import script from "./StatusVerificationRejected.vue?vue&type=script&lang=js&"
export * from "./StatusVerificationRejected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports